export const EnumPaisEndereco = {
  Brasil: 'BRASIL',
};
